import { Component, ViewChild, input, output, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { HttpService } from 'src/app/services/http.service';
import { ConfigurationSaisieDonneesAnalyse } from '../../bo/configurationSaisieDonneesAnalyse';
import { DonneeAnalyse } from '../../bo/donneeAnalyse';
import { Projet } from '../../bo/projet';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { TraductionService } from '../../services/traduction.service';
import { UtilisateurService } from '../../services/utilisateur.service';
import { DonneesAnalyseModaleComponent } from '../donnees-analyse-modale/donnees-analyse-modale.component';
import { AccessPermissionType } from 'src/app/bo/accessPermisionType';
import { KeycloakUtilisateurService } from 'src/app/services/keycloak/keycloak-utilisateur.service';

export enum TypeParent {
  Projet,
  Tir,
  Noeud
}
@Component({
  selector: 'app-donnees-analyse',
  templateUrl: './donnees-analyse.component.html',
  styleUrls: ['./donnees-analyse.component.scss'],
  standalone: false
})

export class DonneesAnalyseComponent {
  @ViewChild('modalExport') modalExport: ModalDirective;
  tabConfigSaisie = input<ConfigurationSaisieDonneesAnalyse[]>();
  tabDonneesAnalyse = input<DonneeAnalyse[]>();
  donneesChargees = input<boolean>();
  estProjet = input<boolean>();
  estTir = input<boolean>();
  tirId = input<number>();
  typeParent = input<TypeParent>();
  rechargerDonnees = output<boolean>();
  projet = input<Projet>(null);
  inProjetDetail = input<boolean>(false);
  modalModif: BsModalRef;
  langueCourante = toSignal(this.tradService.langueCourante$, { initialValue: this.tradService.translate.currentLang });
  estUtilisateur = signal<boolean>(false);
  estClient = signal<boolean>(false);
  aucuneDonnee = signal<boolean>(false);
  TypeParent = TypeParent;
  isResponsable: boolean;
  AccessPermissionEnum = AccessPermissionType;
  siteCurrency = signal<string>('');




  constructor(private readonly utilService: UtilisateurService, private readonly userProfileService: KeycloakUtilisateurService,
    private readonly modalService: BsModalService, private readonly tradService: TraductionService, private readonly fonctionsService: FonctionsService,
    private readonly translate: TranslateService, private readonly http: HttpService) {
    this.estClient.set(userProfileService.isGuest);
    this.estUtilisateur.set(!userProfileService.isGuest);
    this.siteCurrency.set(this.utilService.currentSite().currency);
  }

  ouvrirModaleModif(donneeAnalyse: DonneeAnalyse) {

    var initialState = {
      tabConfigSaisie: this.tabConfigSaisie(),
      donneeAnalyseEntree: donneeAnalyse,
      estProjet: this.typeParent() === TypeParent.Projet,
      siteId: this.utilService.currentSite().siteId
    };
    this.modalModif = this.modalService.show(DonneesAnalyseModaleComponent, { backdrop: true, ignoreBackdropClick: true, keyboard: false, initialState });
    this.modalModif.content.modaleFermee.subscribe(success => {
      if (success)
        this.rechargerDonnees.emit(true);
    });
  }

  lancerExport() {
    var startLoader = setTimeout(() => {
      this.fonctionsService.loading_screen(true);
    }, 300);
    this.aucuneDonnee.set(false);
    this.http.get<boolean>('Projects/' + this.projet().projetId + '/GotAnalysisData').subscribe(resultat => {
      clearTimeout(startLoader);
      this.fonctionsService.loading_screen(false);
      if (resultat)
        this.exportDonneeAnalyse();
      else {
        this.aucuneDonnee.set(true);
        this.modalExport.show();
      }
    }, () => {
      clearTimeout(startLoader);
      this.fonctionsService.loading_screen(false);
    });
  }

  exportDonneeAnalyse() {
    var startLoader = setTimeout(() => {
      this.modalExport.show();
    }, 300);

    this.http.downloadFile('Projects/' + this.projet().projetId + '/ExportAnalysisData').subscribe((resultat: ArrayBuffer) => {
      const blob = new Blob([resultat], { type: 'text/csv' });
      //if (window.navigator.msSaveOrOpenBlob) {
      //  window.navigator.msSaveOrOpenBlob(blob, this.projet().nom + ".csv");
      //} else {
      const url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = this.projet().nom + ".csv";
      document.body.appendChild(a);
      a.click();

      this.modalExport.hide();
      clearTimeout(startLoader);
      setTimeout(() => {
        a.remove();
      }, 100);
    }, () => {
      this.translate.get('GLOBAL.ERREUR_RECUP_DONNEES').subscribe(trad => {
        this.fonctionsService.launch_toast(false, false, trad)
      });
      this.modalExport.hide();
      clearTimeout(startLoader);
    });
  }

}
